import React from 'react';

import { cn } from '@/lib/utils';

interface CardProps {
    className?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
    children?: React.ReactNode;
}

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
    ({ children, className, onClick, ...props }, ref) => {
        return (
            <div
                ref={ref}
                className={cn(
                    'bg-white border border-solid border-neutral-100 px-3 py-2 rounded-lg text-left',
                    className,
                    onClick && 'cursor-pointer border border-neutral-100 hover:border-neutral-300',
                )}
                {...props}
                onClick={onClick}
            >
                {children}
            </div>
        );
    },
);

Card.displayName = 'Card';
